import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=9b15f044&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=9b15f044&prod&scoped=true&lang=scss&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=9b15f044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15f044",
  null
  
)

export default component.exports